import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    menuActive: localStorage.getItem('menuActive') || '/home', // 默认激活菜单
    infiniteScrollDisabled: true // 滚动触底是否禁用开关
  },
  mutations: {
    setMenuActive (state, val) {
      state.menuActive = val;
    },
    setInfiniteScrollDisabled (state, val) {
      state.infiniteScrollDisabled = val;
    }
  },
  getters: {
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js